export default __webpack_public_path__ + "static/img1CL-265e10fae33bb596a252d13bc98b874d.png";